import React, { useEffect, useState } from "react";
import {
	BrowserRouter as Router,
	useLocation,
	useNavigate,
} from "react-router-dom";
import "i18n";
import { useTranslation } from "react-i18next";
// import { ToastContainer, Zoom } from 'react-toastify';

import { AppRoutes, routeConstants } from "navigation";
import { ErrorBoundary } from "modules/errors";

import { Spinner } from "modules/loaders";
import Navbar from "components/Navbar/Navbar";
import MobileNavbar from "components/Navbar/MobileNavbar";
import { Provider } from "react-redux";
import store from "./store";
import Sidebar from "components/Sidebar/Sidebar";
import { checkTokenValidity } from "utils/cookie";

const RouteProtection: React.FC = () => {
	const navigate = useNavigate();

	useEffect(() => {
		if (!checkTokenValidity()) {
			navigate(routeConstants.login.route);
		}
	}, [navigate]);

	return null;
};

const MainContent = () => {
	const location = useLocation();
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const isNotLoginRoute = location.pathname !== routeConstants.login.route;
	const isNotChatRoute = location.pathname !== routeConstants.chat.route;

	// Determine if the sidebar should be displayed
	const shouldShowSidebar = isNotLoginRoute && isNotChatRoute;

	return (
		<div className={`grid ${shouldShowSidebar && "grid-cols-maxFr"}`}>
			{shouldShowSidebar && <Sidebar />}
			<AppRoutes />
		</div>
	);
};

const App: React.FC = (): JSX.Element => {
	const [isLoading, setIsLoading] = useState(false);

	if (isLoading) {
		return <Spinner />;
	}

	return (
		<ErrorBoundary>
			<Provider store={store}>
				<Router>
					<RouteProtection />
					{/* <ToastContainer
					position="top-right"
					autoClose={3000}
					limit={3}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
					theme="dark"
					transition={Zoom}
				/> */}

					<MainContent />
					{/* <AppRoutes /> */}
				</Router>
			</Provider>
		</ErrorBoundary>
	);
};

export default App;
